import axios from 'axios';
import {
  QueryStatus, useMutation, useQuery, useQueryClient,
} from 'react-query';
import { NIL } from 'uuid';
import { ContactInfo, getEmptyContactInfo } from '../models/contactInfo';

const getContactById = async (contactId: string) => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}contacts/${contactId}`);
  return data;
};

const postContact = async (contact: ContactInfo) => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  if (contact.id !== NIL) {
    await axios.post(`${apiUrl}contacts/${contact.id}`, contact);
  } else {
    await axios.post(`${apiUrl}contacts`, contact);
  }
};

interface ContactProps {
  id: string;
  onSuccess?: (data: ContactInfo) => void;
}
const useContact = (props: ContactProps): {
  data: any,
  status: QueryStatus,
  setContact: (data: ContactInfo) => Promise<unknown>
} => {
  const queryClient = useQueryClient();
  const { status, data } = useQuery(['contact', props.id], () => getContactById(props.id), {
    onSuccess: (results) => {
      if (props.id === '' || props.onSuccess === undefined) return;
      props.onSuccess(results);
    },
    enabled: props.id !== '' && props.id !== NIL,
    refetchOnWindowFocus: false,
  });

  const mutation = useMutation((newData: ContactInfo) => postContact(newData), {
    onSuccess: async (response, variables) => {
      await queryClient.invalidateQueries('contacts');
      await queryClient.invalidateQueries(['contact', variables.id]);
    },
  });

  const setContact = (contactInfo: ContactInfo) => mutation.mutateAsync(contactInfo);

  if (props.id === NIL) {
    return {
      data: getEmptyContactInfo(), setContact, status: 'success',
    };
  }
  return { data, setContact, status };
};

export default useContact;
